import { createRoot } from 'react-dom/client';
import App from './App';
import * as serviceWorker from './serviceWorker';
import PiwikPro from '@piwikpro/react-piwik-pro';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DNS,
  integrations: [new BrowserTracing()],
  environment: process.env.REACT_APP_SENTRY_NODE_ENV,
  tracesSampleRate: 1.0,
  enabled: Boolean(process.env.REACT_APP_SENTRY_IS_ENABLED === 'true')
});

PiwikPro.initialize(process.env.REACT_APP_PIWIK_PRO_CONTAINER_ID, process.env.REACT_APP_PIWIK_PRO_CONTAINER_URL);

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
